import {create} from 'zustand';

const authStore = create((set) => ({
	confirmId:'',
	phoneNumber:'',
	setConfirmId: (confirmId) => set({confirmId}),
	setPhoneNumber: (phoneNumber) => set({phoneNumber}),
}));

export default authStore;